import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments';
import { Processor } from '../../models';
import { AuthenticationService, DialogService, ServicesService, ProcessorService } from '../../services';
import { UploaderModalComponent } from '../uploader-modal/uploader-modal.component';
import { Observable, Subscription } from 'rxjs';
import { JobUploaderService } from '../../services/standard/job-uploader.service';
import { DownloadService } from '../../services/standard/download.service';

@Component({
  selector: 'prism-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  env = environment;
  localRefSelectedJob = null;
  allJobs$: Observable<any> = this.servicesService.services$;
  allJobsSub: Subscription;
  zipProcessing$ = this.downloadService.zipProcessing$;
  processor: Observable<Processor>;
  serviceCount$: Observable<number>;
  processorProfileInitials = this.authService.processorProfileData$().pipe(map((profile: any) => {
    if (profile) {
      const {firstName, lastName} = profile;
      return `${firstName.charAt(0)}${lastName.charAt(0)}`
    } else {
      return 'A'
    }
  } ))

  constructor(private authService: AuthenticationService,
              private dialogService: DialogService,
              private downloadService: DownloadService,
              private servicesService: ServicesService,
              private jobUploaderService: JobUploaderService
  ) {
  }

  ngOnInit() {
    this.serviceCount$ = this.servicesService.serviceCount$;
    this.allJobsSub = this.allJobs$.subscribe(
      jobs => {
        if (jobs !== null) {
          this.setSelectedUploaderJob(jobs[0]);
          this.localRefSelectedJob = jobs[0];
        }
      },
      err => console.error(err),
      () => this.allJobsSub.unsubscribe()
    );
    this.processor = this.authService.processorProfileData$()
  }

  setSelectedUploaderJob(job) {
    this.localRefSelectedJob = job;
    this.jobUploaderService.setSelectedUploaderService(job);
  }

  onLogout() {
    this.authService.logout();
  }

  openUploaderModal() {
    this.dialogService.openDialog(UploaderModalComponent, {
      jobsCount: this.servicesService.serviceCount
    }, {height: '90vh', panelClass: 'base-modal-dialog'});
  }
}
